import { render, staticRenderFns } from "./saved-searches-settings.vue?vue&type=template&id=55e16c7a"
import script from "./saved-searches-settings.vue?vue&type=script&lang=ts"
export * from "./saved-searches-settings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports